import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/auth-tokens.css';

const FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

function MeduriLockup({ size = 'md', onClick }) {
  const dim = size === 'lg' ? 48 : 40;
  const fs = size === 'lg' ? 22 : 18;
  const wmFs = size === 'lg' ? 24 : 20;
  return (
    <a onClick={onClick} style={{ display: 'inline-flex', alignItems: 'center', gap: 12, textDecoration: 'none', cursor: onClick ? 'pointer' : 'default' }}>
      <div style={{ width: dim, height: dim, borderRadius: 12, background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ color: '#fff', fontWeight: 900, fontSize: fs, letterSpacing: '0.02em', fontFamily: FONT }}>M</span>
      </div>
      <span style={{ fontWeight: 700, fontSize: wmFs, color: '#000', letterSpacing: '-0.01em', fontFamily: FONT }}>Meduri</span>
    </a>
  );
}

function AuthFooter() {
  return (
    <div style={{ fontFamily: FONT, fontSize: 12, color: '#64748B', display: 'flex', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' }}>
      <span>© 2026 Meduri LLC.</span>
      <div style={{ display: 'flex', gap: 20 }}>
        <Link to="/legal/privacy" style={{ color: '#64748B', textDecoration: 'none' }}>Privacy</Link>
        <Link to="/legal/terms" style={{ color: '#64748B', textDecoration: 'none' }}>Terms</Link>
        <Link to="/legal/baa" style={{ color: '#64748B', textDecoration: 'none' }}>BAA</Link>
        <a href="mailto:support@meduri.health" style={{ color: '#64748B', textDecoration: 'none' }}>support@meduri.health</a>
      </div>
    </div>
  );
}

function Stat({ n, l }) {
  return (
    <div>
      <div style={{ fontFamily: FONT, fontSize: 28, fontWeight: 700, color: '#fff', lineHeight: 1 }}>{n}</div>
      <div style={{ fontFamily: FONT, fontSize: 12, color: 'rgba(255,255,255,0.65)', marginTop: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{l}</div>
    </div>
  );
}

function AuthShell({ layout = 'centered', children, onLogoClick, wide = false }) {
  if (layout === 'split') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', gridTemplateColumns: '1fr 1fr', background: '#fff', fontFamily: FONT }}>
        {/* Left — form */}
        <div style={{ display: 'flex', flexDirection: 'column', padding: '40px 56px', minWidth: 0 }}>
          <MeduriLockup onClick={onLogoClick} />
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 0' }}>
            <div style={{ width: '100%', maxWidth: wide ? 560 : 440 }}>{children}</div>
          </div>
          <AuthFooter />
        </div>
        {/* Right — value panel */}
        <div style={{ background: '#000', color: '#fff', padding: '40px 56px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderLeft: '0.4px solid #000' }}>
          <div style={{ fontFamily: FONT, fontSize: 14, fontWeight: 700, letterSpacing: '0.02em', color: '#fff', opacity: 0.7 }}>FOR INDEPENDENT PRACTICES</div>
          <div>
            <h2 style={{ fontFamily: FONT, fontSize: 40, fontWeight: 700, lineHeight: 1.05, margin: 0, textWrap: 'balance' }}>
              Recover the revenue you&rsquo;re owed. Stop writing appeals by hand.
            </h2>
            <p style={{ fontFamily: FONT, fontSize: 16, lineHeight: 1.55, marginTop: 24, color: 'rgba(255,255,255,0.75)', maxWidth: 480 }}>
              Meduri turns denial letters and ERAs into HIPAA-compliant appeals in seconds.
              Fax them straight to the payer, track outcomes, and get back to seeing patients.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24, marginTop: 56 }}>
              <Stat n="68%" l="Average win rate" />
              <Stat n="4.2d" l="To payer reply" />
              <Stat n="$1.2k" l="Recovered / clinic / mo" />
            </div>
          </div>
          <div style={{ fontFamily: FONT, fontSize: 13, color: 'rgba(255,255,255,0.55)', borderTop: '0.4px solid rgba(255,255,255,0.25)', paddingTop: 20 }}>
            HIPAA-compliant · BAA available · SOC&nbsp;2 in progress
          </div>
        </div>
      </div>
    );
  }

  if (layout === 'fullbleed') {
    return (
      <div style={{ minHeight: '100vh', background: '#fff', fontFamily: FONT, display: 'flex', flexDirection: 'column' }}>
        <header style={{ padding: '28px 48px', borderBottom: '0.4px solid #000' }}>
          <MeduriLockup onClick={onLogoClick} />
        </header>
        <main style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '80px 48px' }}>
          <div style={{ width: '100%', maxWidth: wide ? 720 : 520 }}>{children}</div>
        </main>
        <footer style={{ padding: '20px 48px', borderTop: '0.4px solid #000' }}><AuthFooter /></footer>
      </div>
    );
  }

  // centered (default)
  return (
    <div style={{ minHeight: '100vh', background: '#fff', fontFamily: FONT, display: 'flex', flexDirection: 'column' }}>
      <header style={{ padding: '24px 32px' }}>
        <MeduriLockup onClick={onLogoClick} />
      </header>
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
        <div style={{ width: '100%', maxWidth: wide ? 640 : 440 }}>{children}</div>
      </main>
      <footer style={{ padding: '20px 32px', maxWidth: 1200, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
        <AuthFooter />
      </footer>
    </div>
  );
}

export { MeduriLockup };
export default AuthShell;
